import { TIER_COLORS } from "@/lib/reward-tiers";

export default function TierBadge({ level, size = "md" }) {
  const c = TIER_COLORS[level] || TIER_COLORS.Starter;
  const sizes = {
    sm: "text-[10px] px-2 py-0.5",
    md: "text-xs px-3 py-1",
    lg: "text-sm px-4 py-1.5",
  };
  return (
    <span
      data-testid={`tier-badge-${level?.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium tracking-wider uppercase ${sizes[size]}`}
      style={{ backgroundColor: c.bg, color: c.ink }}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.ink }} />
      {level}
    </span>
  );
}
